import script from "./StepExtraImages.vue?vue&type=script&setup=true&lang=js"
export * from "./StepExtraImages.vue?vue&type=script&setup=true&lang=js"

import "./StepExtraImages.vue?vue&type=style&index=0&id=9428913e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9428913e"]])

export default __exports__